export const IMAGE_FRAME = {
  square: 'square',
  circle: 'circle',
} as const;

type ObjectValues<T> = T[keyof T];
export type ImageFrameType = ObjectValues<typeof IMAGE_FRAME>;
